import * as React from "react";
const SvgFiRrBowlScoop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-bowl-scoop_svg__a)">
      <path d="M1.9 10.995a1 1 0 0 0 1.095-.896C3.456 5.482 7.327 2 12 2s8.544 3.482 9.005 8.1c.052.516.562 1.006 1.095.896a1 1 0 0 0 .896-1.095C22.432 4.256 17.704 0 12 0S1.568 4.256 1.005 9.9a1 1 0 0 0 .896 1.095zM23.674 13.811A1.86 1.86 0 0 0 22.138 13H1.862c-.615 0-1.19.303-1.536.811a1.86 1.86 0 0 0-.198 1.726s.169.423.198.472c1.622 2.706 3.927 2.964 5.973 2.992h4.7v3H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-3h4.716c2.032-.028 4.337-.286 5.959-2.992.029-.049.198-.472.198-.472a1.86 1.86 0 0 0-.198-1.726m-1.758 1.238C20.922 16.66 19.705 16.972 17.7 17H6.31c-2.017-.028-3.233-.34-4.228-1.951L2.063 15h19.87l-.02.049z" />
    </g>
    <defs>
      <clipPath id="fi-rr-bowl-scoop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBowlScoop;
